import { Link } from "react-router-dom";
import { BatteryCharging, ShieldCheck, Zap, ArrowRight } from "lucide-react";
import { IMAGES, BRAND, buildWhatsAppLink } from "@/data/site";

export default function InciAkuPromo() {
  return (
    <section
      data-testid="inci-aku-promo"
      className="relative py-24 lg:py-32 overflow-hidden bg-gradient-to-b from-[#050A1F] via-[#020611] to-[#050A1F]"
    >
      <div className="absolute inset-0 bg-blueprint opacity-30 pointer-events-none" />
      <div className="absolute -top-20 right-0 w-[600px] h-[600px] rounded-full bg-inci-blue/15 blur-[140px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass-blue mb-6">
            <ShieldCheck className="w-3.5 h-3.5 text-inci-blue" />
            <span className="text-xs uppercase tracking-[0.25em] text-inci-blue font-semibold">
              Yetkili Bayi Rozeti
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] text-balance">
            <span className="text-gradient-silver">Orijinal </span>
            <span className="text-inci-blue" style={{
              filter: "drop-shadow(0 0 24px rgba(26,95,202,0.4))",
            }}>
              İnci Akü
            </span>
            <span className="text-gradient-silver"> deneyimi.</span>
          </h2>
          <p className="mt-6 text-white/65 leading-relaxed text-base sm:text-lg max-w-xl">
            Türkiye'nin lider akü üreticisi İnci Akü'nün yetkili bayisi olarak;
            tüm seriler, garantili stoklar, ücretsiz montaj ve eski akünüze
            değer ödemesi tek bir adreste.
          </p>

          <ul className="mt-8 space-y-3 max-w-md">
            {[
              { icon: ShieldCheck, t: "%100 Orijinal Ürün Garantisi" },
              { icon: Zap, t: "Ücretsiz Yerinde Montaj" },
              { icon: BatteryCharging, t: "Eski Akü Değer Ödemesi" },
            ].map(({ icon: Icon, t }) => (
              <li key={t} className="flex items-center gap-4">
                <div className="w-9 h-9 rounded-md bg-inci-blue/15 border border-inci-blue/40 flex items-center justify-center">
                  <Icon className="w-4 h-4 text-inci-blue" />
                </div>
                <span className="text-white/85 font-medium">{t}</span>
              </li>
            ))}
          </ul>

          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <Link
              to="/inci-aku"
              data-testid="inci-aku-detail-btn"
              className="bg-inci-blue hover:bg-inci-blue-light text-white font-semibold px-7 py-3.5 inline-flex items-center gap-2 transition-all"
            >
              Akü Çeşitlerini Gör <ArrowRight className="w-4 h-4" />
            </Link>
            <a
              href={buildWhatsAppLink("Merhaba, İnci Akü modelleri hakkında bilgi almak istiyorum.")}
              target="_blank"
              rel="noreferrer"
              className="border border-gold text-gold hover:bg-gold/10 font-semibold px-7 py-3.5 inline-flex items-center gap-2 transition-all"
            >
              Akü Fiyat Sor
            </a>
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-6 bg-inci-blue/20 blur-3xl rounded-full" />
          <div className="relative aspect-[4/5] sm:aspect-[5/6] rounded-2xl overflow-hidden glass-blue glow-blue">
            <img
              src={IMAGES.battery}
              alt="İnci Akü Yetkili Bayi - orijinal akü stoğu"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#020611] via-transparent to-transparent" />

            {/* Floating badge */}
            <div className="absolute top-5 left-5 glass-strong rounded-xl p-4 max-w-[180px]">
              <div className="text-[10px] uppercase tracking-[0.25em] text-gold font-semibold mb-1">
                Yetkili Bayi
              </div>
              <div className="font-display font-bold text-white leading-tight">
                Star Otogaz × İnci Akü
              </div>
            </div>

            <div className="absolute bottom-5 right-5 glass-strong rounded-xl p-4 flex items-center gap-3 animate-float">
              <div className="w-10 h-10 rounded-full bg-inci-blue flex items-center justify-center">
                <BatteryCharging className="w-5 h-5 text-white" />
              </div>
              <div>
                <div className="text-xs text-white/60">CCA Testi</div>
                <div className="font-bold text-white">
                  Ücretsiz <span className="text-gold">✓</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
